import {PincodeService} from './pincode-service';
import {Observable, of} from 'rxjs';

export class MockPincodeService implements PincodeService {
  private remainingAttempts: number;

  constructor() {
    this.remainingAttempts = 3;
  }

  public verifyPin(pin: string): Observable<boolean> {
    if (pin === '1234') {
      return of(true);
    }
    this.remainingAttempts = this.remainingAttempts - 1;
    if (this.remainingAttempts <= 0) {
      setTimeout(() => this.remainingAttempts = 3, 60000);
    }
    return of(false);
  }

  getRemainingAttempts(): Observable<number> {
    return of(this.remainingAttempts);
  }

  getSuspensionExpiration(): Observable<number> {
    return of(5);
  }
}
